import clsx from 'clsx';

import styles from './WellLiveDataQualityIndicator.module.scss';

export enum DataQualityIndicatorColor {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

interface Props {
  label?: number;
  color: DataQualityIndicatorColor;
}

const WellLiveDataQualityIndicator = ({ color, label }: Props) => {
  return (
    <div className={styles.container}>
      <p className={styles.label}>{label}</p>
      <div className={styles.indicatorsContainer}>
        <div
          role="presentation"
          className={clsx(
            styles.indicator,
            styles.low,
            color === DataQualityIndicatorColor.LOW && styles.active,
          )}
        />
        <div
          role="presentation"
          className={clsx(
            styles.indicator,
            styles.medium,
            color === DataQualityIndicatorColor.MEDIUM && styles.active,
          )}
        />
        <div
          role="presentation"
          className={clsx(
            styles.indicator,
            styles.high,
            color === DataQualityIndicatorColor.HIGH && styles.active,
          )}
        />
      </div>
    </div>
  );
};

export default WellLiveDataQualityIndicator;
